export const T = {
  en_GB: {
    loading: "Loading equity share data...",
    noData: "No equity share data available. Ensure the goal has portfolios with forecasts.",
    notEvaluableNoRiskScore:
      "The goal has no risk score yet, so the equity share ceiling cannot be selected.",
    notEvaluableNoSnapshot:
      "No equity share forecast is available for this goal yet. Regenerate the snapshots.",
    notEvaluableMissingAssetData:
      "A portfolio in this goal has no forecast data, so the goal's equity share cannot be measured.",
    noDataPoints: "No data points to display.",
    year1Label: "Year 1 Equity Share",
    ceilingLabel: "Max Allowed",
    baselineLabel: "Existing Portfolio",
    equity: "Equity",
    nonEquity: "Non-Equity",
    unknown: "Unknown",
    year1Equity: "Year 1 Equity",
    year1NonEquity: "Year 1 Non-Equity",
    year1Unknown: "Year 1 Unknown",
    year1Hint: (date: string) => `${date}, one year after the first deposit`,
    breachMessage: "The goal's year-1 equity share breaches the risk bounds.",
    decisionSaved: "Saved",
    error: "Error",
    fetchError: "Failed to load equity share data.",
    retry: "Retry",
    coverageWarning: (pct: string) =>
      `${pct}% of this goal's assets have no equity share data and count as non-equity in the check`,
    horizon1Y: "1Y",
    horizon5Y: "5Y",
    horizon10Y: "10Y",
    equityShare: "Equity share",
    date: "Date",
    vsMax: "Max",
  },
  nb_NO: {
    loading: "Laster aksjeandelsdata...",
    noData: "Ingen aksjeandelsdata tilgjengelig. Sørg for at målet har porteføljer med prognoser.",
    notEvaluableNoRiskScore:
      "Målet har ingen risikoscore ennå, så aksjeandelsgrensen kan ikke velges.",
    notEvaluableNoSnapshot:
      "Ingen aksjeandelsprognose er tilgjengelig for dette målet ennå. Generer øyeblikksbildene på nytt.",
    notEvaluableMissingAssetData:
      "En portefølje i dette målet mangler prognosedata, så målets aksjeandel kan ikke måles.",
    noDataPoints: "Ingen datapunkter å vise.",
    year1Label: "År 1 aksjeandel",
    ceilingLabel: "Maks tillatt",
    baselineLabel: "Eksisterende portefølje",
    equity: "Aksjer",
    nonEquity: "Ikke-aksjer",
    unknown: "Ukjent",
    year1Equity: "År 1 aksjer",
    year1NonEquity: "År 1 ikke-aksjer",
    year1Unknown: "År 1 ukjent",
    year1Hint: (date: string) => `${date}, ett år etter første innskudd`,
    breachMessage: "Målets aksjeandel i år 1 bryter risikogrensene.",
    decisionSaved: "Lagret",
    error: "Feil",
    fetchError: "Kunne ikke laste aksjeandelsdata.",
    retry: "Prøv igjen",
    coverageWarning: (pct: string) =>
      `${pct}% av dette målets eiendeler mangler aksjeandelsdata og regnes som ikke-aksjer i kontrollen`,
    horizon1Y: "1 år",
    horizon5Y: "5 år",
    horizon10Y: "10 år",
    equityShare: "Aksjeandel",
    date: "Dato",
    vsMax: "Maks",
  },
} as const;
